



















































































































import Vue from "vue";
import Page from "@/components/Page.vue";
import MsIcon from "@/components/MsIcon.vue";
import Agreement from "@/components/Agreement.vue";
import { env } from "@/env";
import axios, { AxiosError } from "axios";
import { getQueryParams, removeQueryParams, setQueryParam } from "../utils";
import { state as appState } from "@/state";
import { AppAnalytics } from "@/analytics";
import DropDown from "@/components/DropDown.vue";

/* 
this is GraphAPI consent page
*/
export default Vue.extend({
  components: {
    Page,
    MsIcon,
    Agreement,
    DropDown
  },
  data() {
    return {
      agree: false,
      isLoading: false,
      consentError: false,
      isSurveilSuccess: false,
      from: "",
      wasCompanyNameFocus: false,
      companyName: "",
      wasOrgEmailFocus: false,
      orgEmail: "",
      statusCode: 200,
      regions: [] as Array<{ api: string; name: string; selected: boolean }>
    };
  },
  computed: {
    regionUrl(): string {
      return this.regions.find(f => f.selected)?.api || "?";
    },
    title(): string {
      if (this.statusCode === 409) {
        return "Wait!";
      }
      if (this.consentError || this.statusCode !== 200) {
        return "Oops..something went wrong";
      }

      if (this.isSurveilSuccess) {
        return "Success!";
      }
      return "Welcome to Cognni";
    },
    subtitle(): string {
      if (this.isSurveilSuccess) {
        return "You have successfully connected your organization's M365 Exchange to Cognni's Information Intelligence. You can now close this tab and navigate back to your Quantum 365 environment.Once back in Quantum 365, hit refresh and connect your M365 Audit Log.";
      }

      if (this.consentError) {
        return "Are you sure you have Global Admin Rights?";
      }

      switch (this.statusCode) {
        case 200:
          return "In order to activate Cognni,<br/> a Global Admin User is required to provide MSFT consent";
        default:
          return "";
      }
    },
    isValidCompanyName(): boolean {
      return this.companyName.trim().length > 0;
    },
    isValidEmail(): boolean {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.orgEmail).toLowerCase());
    },
    disableBtn(): boolean {
      return this.isLoading || !this.isValidCompanyName || !this.isValidEmail;
    }
  },
  async mounted() {
    AppAnalytics.report({ eventName: "Onboarding_visit page" });
    const params = getQueryParams(location.search);
    const {
      code,
      state,
      error,
      n: name = "",
      u: email = "",
      p: partnerId = "cognni",
      from = "normal"
    } = params;

    this.from = from;

    appState.saveToSession({
      name,
      email,
      partnerId
    });
    console.log("mounted params : ", params);

    this.initRegions().then(() => {
      if (state) {
        try {
          const { regionUrl } = JSON.parse(decodeURIComponent(state));
          this.regions = this.regions.map(r => {
            r.selected = r.api === regionUrl;
            return r;
          });
        } catch (e) {
          console.log("error while parsing 'state' after initRegion :", e);
        }
      }
    });

    if (code && state) {
      try {
        const {
          provider,
          redirectUrl,
          name = "",
          email = "",
          regionUrl = "?",
          partnerId = "cognni",
          from,
          orgEmail = "",
          companyName = ""
        } = JSON.parse(decodeURIComponent(state));
        this.from = from;

        appState.saveToSession({
          name,
          email,
          partnerId
        });

        this.autoFillInputs({
          orgEmail,
          companyName
        });

        this.auth({
          code,
          provider,
          redirectUrl,
          regionUrl,
          orgEmail,
          companyName
        });
      } catch (e) {
        console.log("error parsing state param : ", e);
      }
    }
    if (error) {
      this.consentError = true;
    }
    console.log(location.href);
    removeQueryParams(this.$route.path);
  },
  methods: {
    async initRegions(): Promise<void> {
      try {
        const res = await axios.get("/locations/list");
        this.regions = res.data;
        // select first by default
        this.regions[0].selected = true;
        this.setBaseUrl(this.regions[0].api);
      } catch (e) {
        // fallback
        const { api, naApi } = await env();
        this.regions = [
          { name: "General", selected: true, api },
          {
            name: "North America",
            selected: false,
            api: naApi
          }
        ];
        this.setBaseUrl(this.regions[0].api);
        console.log("initRegions , e", e);
      }
    },

    onRegionSelectd(item: any) {
      this.regions = this.regions.map(region => {
        region.selected = region.name === item.name;
        return region;
      });
      this.setBaseUrl(item.api);
    },
    setBaseUrl(url: string) {
      console.log("setBaseUrl  :", url);
      axios.defaults.baseURL = url;
    },
    async redirectToMs() {
      if (this.isLoading || !this.agree) {
        return;
      }
      const analyticsPayload = {
        name: appState.name(),
        email: appState.email(),
        companyName: this.companyName,
        orgContactEmail: this.orgEmail,
        partnerId: appState.partnerId()
      };
      AppAnalytics.report({
        eventName: "Onboarding_click on graph api consent",
        extra: analyticsPayload
      });
      const res = await axios.get("/consent/ms/url");
      const { redirect_uri: redirectUrl, state: provider } = getQueryParams(
        res.data
      );
      const url = setQueryParam(
        res.data,
        "state",
        JSON.stringify({
          provider,
          regionUrl: this.regionUrl,
          redirectUrl,
          ...analyticsPayload,
          from: this.from,
          companyName: this.companyName,
          orgEmail: this.orgEmail
        })
      );

      console.log("redirectToMs url : ", url);
      window.open(url, "_self");
    },

    autoFillInputs(params: { orgEmail: string; companyName: string }): void {
      this.agree = true;
      this.companyName = params.companyName;
      this.orgEmail = params.orgEmail;
    },

    async auth(params: {
      code: string;
      provider: string;
      redirectUrl: string;
      regionUrl: string;
      companyName: string;
      orgEmail: string;
    }) {
      const {
        code,
        provider,
        redirectUrl,
        regionUrl,
        companyName,
        orgEmail
      } = params;
      try {
        this.isLoading = true;
        console.log("redirectUrl : ", redirectUrl);

        const res = await axios({
          method: "post",
          baseURL: regionUrl,
          url: "/consent/ms",
          data: {
            code,
            provider,
            redirectUrl,
            partnerId: appState.partnerId(),
            orgName: companyName,
            orgContactEmail: orgEmail
          }
        });
        const { message: token } = res.data;

        // notify analytics
        await AppAnalytics.report({
          eventName: "Onboarding_graphapi_consent_success",
          token,
          extra: {
            name: appState.name(),
            email: appState.email(),
            companyName: companyName,
            orgContactEmail: orgEmail,
            partnerId: appState.partnerId()
          }
        });

        if (this.from === "surveil") {
          this.isSurveilSuccess = true;
          return;
        }

        const { dashboard, dashboardUSA } = await env();
        const selectedDashboardUrl = regionUrl.includes("us-")
          ? dashboardUSA
          : dashboard;
        const cognniApp =
          selectedDashboardUrl +
          "?token=" +
          encodeURIComponent(token) +
          "&regionUrl=" +
          encodeURIComponent(regionUrl);

        window.open(cognniApp, "_self");
      } catch (error) {
        this.statusCode = (error as AxiosError).response?.status || 500;
        // 1. get status code
        console.log("ConsentView auth() , error: ", error);
        AppAnalytics.report({
          eventName: "Onboarding_graphapi consent_fails",
          extra: { error }
        });
      } finally {
        this.isLoading = false;
      }
    },

    async notAnAdmin() {
      AppAnalytics.report({
        eventName: "Onboarding_click on not global admin"
      });
      const { api } = await env();
      this.setBaseUrl(api);
      this.$router.push({ name: "invite" });
    }
  }
});
